module.exports = __webpack_public_path__ + "static/media/discord.fcc50332.svg";